import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import ImageGalleryItem from "./ImageGalleryItem.vue";
import store from "@/store";

const ImageGalleryItemNode = Node.create({
  name: "imagegalleryitem",

  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },

  draggable: true,

  addAttributes() {
    return {
      src: {
        default: null
      },
      "aspect-ratio": {
        default: null
      },
      fill: {
        default: store.getters.getDefaultBackground
      },
      contain: {
        default: "1"
      },
      left: {
        default: 20
      },
      top: {
        default: 20
      },
      right: {
        default: 80
      },
      bottom: {
        default: 80
      }
    };
  },

  addCommands() {
    return {
      setImageGalleryItem: () => ({ chain }) => {
        return chain()
          .setNode(this.name)
          .run();
      },

      toggleImageGalleryItem: () => ({ chain }) => {
        return chain()
          .toggleNode(this.name)
          .run();
      },

      unsetImageGalleryItem: () => ({ chain }) => {
        return chain()
          .deleteNode(this.name)
          .run();
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: "image-gallery-item"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "image-gallery-item",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageGalleryItem);
  }
});

export default ImageGalleryItemNode;
